import { forwardRef } from 'react';
import SharedTextField from '@shared/components/text-field';

const TextField = forwardRef((props, ref) => (
  <SharedTextField fullWidth ref={ ref } { ...props } />
));

export default TextField;
